import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Grid,
  Typography,
  IconButton,
  Collapse,
  List,
  ListItem,
  ListItemText,
  TextField,
  InputAdornment,
  Card,
  CardContent,
  CardMedia,
  Button,
  Modal,
  Chip,
} from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Divider from "@mui/material/Divider";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import VerifiedIcon from "@mui/icons-material/Verified";
import ShieldIcon from "@mui/icons-material/Shield";
import PaymentsIcon from "@mui/icons-material/Payments";
import InspectionIcon from "@mui/icons-material/FactCheck";
import "./preowned.css";
import { debounce } from "lodash";

const trustBadges = [
  { icon: <VerifiedIcon sx={{ color: "#D12230", fontSize: 28 }} />, label: "Certified Pre-Owned" },
  { icon: <InspectionIcon sx={{ color: "#D12230", fontSize: 28 }} />, label: "150-Point Inspection" },
  { icon: <ShieldIcon sx={{ color: "#D12230", fontSize: 28 }} />, label: "Warranty Included" },
  { icon: <PaymentsIcon sx={{ color: "#D12230", fontSize: 28 }} />, label: "Easy EMI Options" },
];

const CarPage = (props) => {
  const [isBudgetOpen, setIsBudgetOpen] = useState(false);
  const [selectedBudget, setSelectedBudget] = useState(null);
  const [isSellerTypeOpen, setIsSellerTypeOpen] = useState(false);
  const [isOwnerOpen, setIsOwnerOpen] = useState(false);
  const [isFuelOpen, setIsFuelOpen] = useState(false);
  const [selectedFuels, setSelectedFuels] = useState([]);
  const [isTransmissionOpen, setIsTransmissionOpen] = useState(false);
  const [selectedTransmissions, setSelectedTransmissions] = useState([]);
  const [query, setQuery] = useState("");
  const [isBrandOpen, setIsBrandOpen] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [selectedOwners, setSelectedOwners] = useState([]);

  const toggleFuelDropdown = () => setIsFuelOpen(!isFuelOpen);
  const toggleBrandDropdown = () => setIsBrandOpen(!isBrandOpen);
  const toggleTransmissionDropdown = () => setIsTransmissionOpen(!isTransmissionOpen);

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setSelectedFuels((prevSelected) =>
      checked ? [...prevSelected, name] : prevSelected.filter((fuel) => fuel !== name)
    );
    props.viewAllOldCar(selectedBudget, selectedFuels, selectedTransmissions, selectedOwners, query, selectedBrand);
  };

  const handleCheckboxChangeBrand = (event) => {
    const { name, checked } = event.target;
    setSelectedBrand((prevSelected) =>
      checked ? [...prevSelected, name] : prevSelected.filter((brand) => brand !== name)
    );
    props.viewAllOldCar(selectedBudget, selectedFuels, selectedTransmissions, selectedOwners, query, selectedBrand);
  };

  const handleTransmissionChange = (event) => {
    const { name, checked } = event.target;
    setSelectedTransmissions((prevSelected) =>
      checked ? [...prevSelected, name] : prevSelected.filter((trans) => trans !== name)
    );
    props.viewAllOldCar(selectedBudget, selectedFuels, selectedTransmissions, selectedOwners, query, selectedBrand);
  };

  const handleOwnerChange = (event) => {
    const { name, checked } = event.target;
    setSelectedOwners((prevSelected) =>
      checked ? [...prevSelected, name] : prevSelected.filter((owner) => owner !== name)
    );
    props.viewAllOldCar(selectedBudget, selectedFuels, selectedTransmissions, selectedOwners, query, selectedBrand);
  };

  const debouncedSearch = useCallback(
    debounce((searchQuery) => {
      if (searchQuery) {
        props.viewAllOldCar(selectedBudget, selectedFuels, selectedTransmissions, selectedOwners, searchQuery, selectedBrand);
      }
    }, 500),
    []
  );

  const toggleBudgetDropdown = () => setIsBudgetOpen(!isBudgetOpen);

  const handleBudgetSelect = (budget) => {
    setSelectedBudget(budget);
    props.viewAllOldCar(budget, selectedFuels, selectedTransmissions, selectedOwners, query, selectedBrand);
  };

  const handleInputChange = (e) => {
    const searchQuery = e.target.value;
    setQuery(searchQuery);
    debouncedSearch(searchQuery);
  };

  const handleClearAll = () => {
    setQuery("");
    setSelectedBudget("");
    setSelectedFuels([]);
    setSelectedBrand([]);
    setSelectedTransmissions([]);
    setSelectedOwners([]);
    props.viewAllOldCar("", [], [], [], "", []);
  };

  const toggleOwnerDropdown = () => setIsOwnerOpen(!isOwnerOpen);

  const [openModal, setOpenModal] = useState(false);
  const [setSelectedCar] = useState(null);
  const navigate = useNavigate();

  const handleOpenModal = (car) => {
    setSelectedCar(car);
    setOpenModal(true);
  };

  const handleCloseModal = () => setOpenModal(false);

  const [currentImageIndex, setCurrentImageIndex] = useState(
    Array(props.oldcar.all_oldCars.length).fill(0)
  );

  const handleNextImage = (carIndex) => {
    setCurrentImageIndex((prevState) =>
      prevState.map((index, idx) =>
        idx === carIndex
          ? (index + 1) % props.oldcar.all_oldCars[carIndex].image.length
          : index
      )
    );
  };

  const handlePrevImage = (carIndex) => {
    setCurrentImageIndex((prevState) =>
      prevState.map((index, idx) =>
        idx === carIndex
          ? (index - 1 + props.oldcar.all_oldCars[carIndex].image.length) %
            props.oldcar.all_oldCars[carIndex].image.length
          : index
      )
    );
  };

  const handleImageClick = (carId, brand) => {
    navigate(`/car-details/${carId}/${brand}`);
  };

  useEffect(() => {
    props.viewAllOldCar(selectedBudget, selectedFuels, selectedTransmissions, selectedOwners, query, selectedBrand);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [selectedBudget, selectedFuels, selectedTransmissions, selectedOwners, query, selectedBrand]);

  const filterSectionStyle = {
    width: "100%",
    marginBottom: 2,
  };

  const filterHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 14px",
    cursor: "pointer",
    borderRadius: "8px",
    backgroundColor: "#fff",
    border: "1.5px solid #eee",
    transition: "border-color 0.2s",
    "&:hover": { borderColor: "#D12230" },
  };

  return (
    <Box sx={{ marginTop: { md: "95px", sm: "90px", xs: "93px" } }}>
      {/* Hero Banner */}
      <div id="banner-image-preowned">
        <div id="write">
          <Typography
            variant="h4"
            sx={{
              fontFamily: "Roboto, sans-serif",
              fontWeight: "bold",
              textAlign: "center",
              fontSize: { md: "38px", xs: "20px", sm: "28px" },
              color: "white",
              letterSpacing: "2px",
              px: 2,
            }}
          >
            CERTIFIED PRE-OWNED CARS
          </Typography>
          <Typography
            sx={{
              fontFamily: "Roboto, sans-serif",
              textAlign: "center",
              fontSize: { md: "16px", xs: "12px", sm: "14px" },
              color: "rgba(255,255,255,0.75)",
              mt: 1.5,
              px: 2,
            }}
          >
            All Makes &amp; Models at MG Central
          </Typography>
        </div>
      </div>

      {/* Description + Trust Badges */}
      <Box sx={{ px: { xs: 2, md: 8 }, pt: 4, pb: 2 }}>
        <Typography
          variant="h4"
          sx={{
            marginBottom: "12px",
            fontWeight: "700",
            fontFamily: "Roboto, sans-serif",
            fontSize: { xs: "20px", md: "28px", sm: "23px" },
          }}
        >
          Certified Pre-Owned Cars for Sale – All Makes &amp; Models at MG Central
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "12px", sm: "13px", md: "15px" },
            color: "#666",
            mb: 3,
            fontFamily: "LatoGoogle, Lato, LatoWeb, sans-serif",
            lineHeight: "1.7",
          }}
        >
          Looking for a certified pre-owned car? MG Central offers a diverse inventory of high-quality, thoroughly inspected used cars from all major brands. Our selection includes SUVs, sedans, hatchbacks, and more, ensuring you find the perfect car to match your lifestyle and budget. Each vehicle is carefully vetted for reliability, offering you a dependable, budget-friendly option without compromising on quality. Shop confidently at MG Central's Pre-Owned Car Section, your trusted destination for certified used cars in Odisha. Drive home with peace of mind today!
        </Typography>

        {/* Trust Badges */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          {trustBadges.map((badge, i) => (
            <Grid item xs={6} sm={3} key={i}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  p: 1.5,
                  borderRadius: "12px",
                  border: "1.5px solid #f0e0e0",
                  backgroundColor: "#fff9f9",
                }}
              >
                {badge.icon}
                <Typography
                  sx={{
                    fontSize: { xs: "11px", md: "13px" },
                    fontWeight: "600",
                    fontFamily: "Roboto, sans-serif",
                    color: "#333",
                  }}
                >
                  {badge.label}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Grid container spacing={2} sx={{ px: { xs: 2, md: 8 }, pb: 4 }}>
        {/* Left Filter Sidebar */}
        <Grid item xs={12} md={3}>
          <Box
            sx={{
              padding: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              justifyContent: "start",
              boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
              borderRadius: "16px",
              position: "sticky",
              top: "20px",
              border: "1px solid #f0f0f0",
              backgroundColor: "#fff",
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                pb: 2,
                borderBottom: "2px solid #f0f0f0",
                mb: 2,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  fontFamily: "Roboto, sans-serif",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                <FilterAltIcon sx={{ color: "#D12230" }} />
                Filters
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#D12230",
                  fontFamily: "LatoGoogle, Lato, LatoWeb, sans-serif",
                  fontWeight: "600",
                  cursor: "pointer",
                  "&:hover": { textDecoration: "underline" },
                }}
                onClick={handleClearAll}
              >
                Clear All
              </Typography>
            </Box>

            {/* Brand */}
            <Box sx={filterSectionStyle}>
              <Box sx={filterHeaderStyle} onClick={toggleBrandDropdown}>
                <Typography variant="body2" sx={{ fontWeight: "bold", fontFamily: "LatoGoogle, Lato, LatoWeb, sans-serif" }}>
                  Brand
                </Typography>
                <IconButton size="small">
                  {isBrandOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </Box>
              <Collapse in={isBrandOpen}>
                <FormGroup sx={{ padding: "8px 14px", maxHeight: "200px", overflowY: "auto" }}>
                  {["MG", "Maruti", "Hyundai", "Tata", "Kia", "Honda", "Toyota", "Mahindra", "Nissan", "Ford", "Volkswagen", "Skoda", "Renault", "Jeep", "Mercedes-Benz", "BMW", "Audi", "Jaguar", "Land Rover", "Volvo"].map((brand) => (
                    <FormControlLabel
                      key={brand}
                      control={
                        <Checkbox
                          name={brand}
                          checked={selectedBrand.includes(brand)}
                          onChange={handleCheckboxChangeBrand}
                          size="small"
                          sx={{ color: "#D12230", "&.Mui-checked": { color: "#D12230" } }}
                        />
                      }
                      label={<Typography sx={{ fontSize: "13px" }}>{brand}</Typography>}
                    />
                  ))}
                </FormGroup>
              </Collapse>
            </Box>

            <Divider sx={{ width: "100%", my: 1 }} />

            {/* Budget */}
            <Box sx={filterSectionStyle}>
              <Box sx={filterHeaderStyle} onClick={toggleBudgetDropdown}>
                <Typography variant="body2" sx={{ fontWeight: "bold", fontFamily: "LatoGoogle, Lato, LatoWeb, sans-serif" }}>
                  Budget
                </Typography>
                <IconButton size="small">
                  {isBudgetOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </Box>
              <Collapse in={isBudgetOpen}>
                <List dense>
                  {["Below ₹3 Lakh", "₹3-5 Lakh", "₹5-8 Lakh", "₹8-12 Lakh", "₹12-20 Lakh", "₹20 Lakh+"].map((budget, index) => (
                    <ListItem
                      button
                      key={index}
                      onClick={() => handleBudgetSelect(budget)}
                      selected={selectedBudget === budget}
                      sx={{
                        borderRadius: "6px",
                        mb: 0.5,
                        "&.Mui-selected": { backgroundColor: "#fff0f0", color: "#D12230" },
                        "&:hover": { backgroundColor: "#fff0f0" },
                      }}
                    >
                      <ListItemText primary={<Typography sx={{ fontSize: "13px" }}>{budget}</Typography>} />
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            </Box>

            <Divider sx={{ width: "100%", my: 1 }} />

            {/* Fuel */}
            <Box sx={filterSectionStyle}>
              <Box sx={filterHeaderStyle} onClick={toggleFuelDropdown}>
                <Typography variant="body2" sx={{ fontWeight: "bold", fontFamily: "LatoGoogle, Lato, LatoWeb, sans-serif" }}>
                  Fuel Type
                </Typography>
                <IconButton size="small">
                  {isFuelOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </Box>
              <Collapse in={isFuelOpen}>
                <FormGroup sx={{ padding: "8px 14px" }}>
                  {["Petrol", "Diesel", "CNG", "LPG", "Electric", "Hybrid"].map((fuel) => (
                    <FormControlLabel
                      key={fuel}
                      control={
                        <Checkbox
                          name={fuel}
                          checked={selectedFuels.includes(fuel)}
                          onChange={handleCheckboxChange}
                          size="small"
                          sx={{ color: "#D12230", "&.Mui-checked": { color: "#D12230" } }}
                        />
                      }
                      label={<Typography sx={{ fontSize: "13px" }}>{fuel}</Typography>}
                    />
                  ))}
                </FormGroup>
              </Collapse>
            </Box>

            <Divider sx={{ width: "100%", my: 1 }} />

            {/* Transmission */}
            <Box sx={filterSectionStyle}>
              <Box sx={filterHeaderStyle} onClick={toggleTransmissionDropdown}>
                <Typography variant="body2" sx={{ fontWeight: "bold", fontFamily: "LatoGoogle, Lato, LatoWeb, sans-serif" }}>
                  Transmission
                </Typography>
                <IconButton size="small">
                  {isTransmissionOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </Box>
              <Collapse in={isTransmissionOpen}>
                <FormGroup sx={{ padding: "8px 14px" }}>
                  {["Automatic", "Manual", "Clutchless Manual"].map((transmission) => (
                    <FormControlLabel
                      key={transmission}
                      control={
                        <Checkbox
                          name={transmission}
                          checked={selectedTransmissions.includes(transmission)}
                          onChange={handleTransmissionChange}
                          size="small"
                          sx={{ color: "#D12230", "&.Mui-checked": { color: "#D12230" } }}
                        />
                      }
                      label={<Typography sx={{ fontSize: "13px" }}>{transmission}</Typography>}
                    />
                  ))}
                </FormGroup>
              </Collapse>
            </Box>

            <Divider sx={{ width: "100%", my: 1 }} />

            {/* Owners */}
            <Box sx={filterSectionStyle}>
              <Box sx={filterHeaderStyle} onClick={toggleOwnerDropdown}>
                <Typography variant="body2" sx={{ fontWeight: "bold", fontFamily: "LatoGoogle, Lato, LatoWeb, sans-serif" }}>
                  Ownership
                </Typography>
                <IconButton size="small">
                  {isOwnerOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </Box>
              <Collapse in={isOwnerOpen}>
                <FormGroup sx={{ padding: "8px 14px" }}>
                  {["First Owner", "Second Owner", "Third or More", "Unregistered Car"].map((owner) => (
                    <FormControlLabel
                      key={owner}
                      control={
                        <Checkbox
                          name={owner}
                          checked={selectedOwners.includes(owner)}
                          onChange={handleOwnerChange}
                          size="small"
                          sx={{ color: "#D12230", "&.Mui-checked": { color: "#D12230" } }}
                        />
                      }
                      label={<Typography sx={{ fontSize: "13px" }}>{owner}</Typography>}
                    />
                  ))}
                </FormGroup>
              </Collapse>
            </Box>
          </Box>
        </Grid>

        {/* Right Side — Car Listing */}
        <Grid item xs={12} md={9}>
          <TextField
            label="Search by car name, brand, or model…"
            variant="outlined"
            fullWidth
            value={query}
            onChange={handleInputChange}
            sx={{
              mb: 3,
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                "&:hover fieldset": { borderColor: "#D12230" },
                "&.Mui-focused fieldset": { borderColor: "#D12230" },
              },
              "& label.Mui-focused": { color: "#D12230" },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "#D12230" }} />
                </InputAdornment>
              ),
            }}
          />

          {/* Car Cards */}
          {Array.isArray(props.oldcar?.all_oldCars) && props.oldcar.all_oldCars.length > 0 ? (
            <Grid container spacing={3}>
              {props.oldcar.all_oldCars.map((car, index) => (
                <Grid item xs={12} sm={6} lg={4} key={car._id || index}>
                  <Card
                    sx={{
                      borderRadius: "16px",
                      overflow: "hidden",
                      boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-6px)",
                        boxShadow: "0 12px 36px rgba(0,0,0,0.15)",
                      },
                    }}
                  >
                    <Box sx={{ position: "relative" }}>
                      <Box onClick={() => handleImageClick(car._id, car.brand)} sx={{ cursor: "pointer" }}>
                        <CardMedia
                          component="img"
                          image={car.image[currentImageIndex[index]]}
                          alt={car.carName}
                          sx={{ height: "220px", objectFit: "cover" }}
                        />
                      </Box>
                      {/* Certified Badge */}
                      <Chip
                        icon={<VerifiedIcon sx={{ fontSize: "14px !important", color: "#fff !important" }} />}
                        label="Certified"
                        size="small"
                        sx={{
                          position: "absolute",
                          top: 10,
                          left: 10,
                          backgroundColor: "#D12230",
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "11px",
                          height: "24px",
                        }}
                      />
                      <IconButton
                        onClick={() => handlePrevImage(index)}
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "8px",
                          transform: "translateY(-50%)",
                          backgroundColor: "rgba(255,255,255,0.85)",
                          width: 32,
                          height: 32,
                          "&:hover": { backgroundColor: "#fff" },
                        }}
                      >
                        <ChevronLeftIcon sx={{ fontSize: "18px" }} />
                      </IconButton>
                      <IconButton
                        onClick={() => handleNextImage(index)}
                        sx={{
                          position: "absolute",
                          top: "50%",
                          right: "8px",
                          transform: "translateY(-50%)",
                          backgroundColor: "rgba(255,255,255,0.85)",
                          width: 32,
                          height: 32,
                          "&:hover": { backgroundColor: "#fff" },
                        }}
                      >
                        <ChevronRightIcon sx={{ fontSize: "18px" }} />
                      </IconButton>
                    </Box>

                    <CardContent sx={{ p: 2.5 }}>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: "800", mb: 0.5, fontSize: "15px", lineHeight: 1.3 }}
                      >
                        {car.carName}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ fontSize: "12px", mb: 1.5 }}
                      >
                        {car.fuelType}
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <Typography
                          variant="body1"
                          sx={{ fontWeight: "bold", color: "#1a1a1a", fontSize: "16px" }}
                        >
                          ₹{car.discountedPrice}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ textDecoration: "line-through", color: "#aaa", fontSize: "13px" }}
                        >
                          ₹{car.price}
                        </Typography>
                        <Chip
                          label="EMI Available"
                          size="small"
                          sx={{
                            ml: "auto",
                            backgroundColor: "#fff0f0",
                            color: "#D12230",
                            fontWeight: "bold",
                            fontSize: "10px",
                            height: "22px",
                          }}
                        />
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Box
              sx={{
                textAlign: "center",
                py: 10,
                color: "#aaa",
              }}
            >
              <SearchIcon sx={{ fontSize: 64, mb: 2, opacity: 0.4 }} />
              <Typography variant="h6" sx={{ fontFamily: "Gill Sans, sans-serif", color: "#888" }}>
                No cars found matching your filters.
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color: "#aaa" }}>
                Try adjusting your search or clearing filters.
              </Typography>
              <Button
                variant="outlined"
                onClick={handleClearAll}
                sx={{
                  mt: 3,
                  borderColor: "#D12230",
                  color: "#D12230",
                  borderRadius: "50px",
                  px: 4,
                  "&:hover": { backgroundColor: "#fff0f0", borderColor: "#D12230" },
                }}
              >
                Clear Filters
              </Button>
            </Box>
          )}
        </Grid>
      </Grid>

      {/* Enquiry Modal */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: 420 },
            bgcolor: "background.paper",
            borderRadius: "16px",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "800", mb: 0.5 }}>
            Get Seller Details
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontSize: "12px" }}>
            Provide your contact details to receive the seller's information.
          </Typography>
          <TextField label="Your Full Name" fullWidth margin="normal" size="small" />
          <TextField label="Mobile Number" fullWidth margin="normal" size="small" />
          <Button
            variant="contained"
            fullWidth
            sx={{
              mt: 2,
              backgroundColor: "#D12230",
              borderRadius: "8px",
              fontWeight: "bold",
              py: 1.3,
              "&:hover": { backgroundColor: "#a81a27" },
            }}
          >
            Submit
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default CarPage;
